const AppLayout = (resolve) =>
  require(['@/components/layout/AppLayout'], resolve);
const _import = (path, subPath) =>
  require('@/components/page/dashboard/' +
    path +
    (subPath ? `/${subPath}` : '/index'));

const routes = {
  path: '/dashboard',
  component: AppLayout,
  meta: {
    title: 'dashboard',
    hidden: true
  },
  redirect: 'budget',
  children: [
    {
      path: 'sample',
      name: 'dashboard-sample',
      meta: {
        title: 'dashboard.sample',
        hidden: true
      },
      component: _import('sample')
    },
    {
      path: 'budget',
      name: 'dashboard-budget',
      meta: {
        title: 'dashboard.budget',
        hidden: true
      },
      component: _import('budget')
    },
    {
      path: 'meeting',
      name: 'dashboard-meeting',
      meta: {
        title: 'dashboard.meeting',
        hidden: true
      },
      component: _import('meeting')
    },
    {
      path: 'effectiveness',
      name: 'dashboard-effectiveness',
      meta: {
        title: 'dashboard.effectiveness',
        hidden: true
      },
      component: _import('effectiveness')
    }
  ]
};

export default routes;



// WEBPACK FOOTER //
// ./src/router/dashboard.js